const URL_REGEX = /https/;
const MENTION_REGEX = /@/;
const HASHTAG_REGEX = /#/;

const URL_BREAK_SYMBOLS = /[,!…\s@#$()]|<br>/;
const MENTION_BREAK_SYMBOLS = /[,!:?.…\s#$()]|<br>|https/;
const HASHTAG_BREAK_SYMBOLS = /[,!:?.…\s@$()]|<br>|https/;

const regexIndexOf = (text: string, regex: RegExp, start: number) => {
  const indexOf = text.slice(start).search(regex);
  return indexOf >= 0 ? indexOf + start : text.length;
};

const selectChunkPart = (input: string, kind: string, breakPattern: RegExp) => {
  const startIndex = input.indexOf(kind);
  const endIndex = regexIndexOf(input, breakPattern, startIndex);
  const before = input.slice(0, startIndex);
  const item = input.slice(startIndex, endIndex);
  const after = input.slice(endIndex);
  return { before, item, after };
};

const highlightNews = (chunk: string, twitter: boolean) => {
  let decoratedChunk = chunk;

  if (URL_REGEX.test(decoratedChunk)) {
    const { before, item, after } = selectChunkPart(
      decoratedChunk,
      'https',
      URL_BREAK_SYMBOLS
    );
    decoratedChunk = `${before}<a href="${item}" target="_blank">${item}</a>${after}`;
  }
  if (twitter) {
    if (MENTION_REGEX.test(decoratedChunk)) {
      const { before, item, after } = selectChunkPart(
        decoratedChunk,
        '@',
        MENTION_BREAK_SYMBOLS
      );
      decoratedChunk = `${before}<a href="https://twitter.com/${item.slice(
        1
      )}" target="_blank">${item}</a>${after}`;
    }
    if (HASHTAG_REGEX.test(decoratedChunk)) {
      const { before, item, after } = selectChunkPart(
        decoratedChunk,
        '#',
        HASHTAG_BREAK_SYMBOLS
      );
      decoratedChunk = `${before}<a href="https://twitter.com/hashtag/${item.slice(
        1
      )}" target="_blank">${item}</a>${after}`;
    }
  }
  return decoratedChunk;
};

export const decorate = (input: string, twitter: boolean) => {
  return input
    .replace(/\n\n/g, '  <br>  ')
    .replace(/\n/g, '  <br>  ')
    .split(/\s/)
    .map((chunk) => highlightNews(chunk, twitter))
    .join(' ')
    .replace(/\s\s/g, '');
};
